<!-- 삭제 -->
<template>
  <div>
    <admin-box-item title="삭제" :useTab="false">
      <div v-if="value.title">{{ value.title }}</div>
      <div v-else>삭제하시겠습니까?</div>
      <div class="btn-group-justify-end">
        <button class="button is-light" @click="cancelModal">취소</button>
        <button class="button is-primary" @click="confirmModal">확인</button>
      </div>
    </admin-box-item>
  </div>
</template>

<script>
  export default {
    props:['data'],
    components: {
    },
    data () {
      return {
        value: {
          id: '',
          url: '',
          title: ''
        }
      }
    },
    created(){
      this.value = this.data;
    },
    watch:{
      data(n){
        if(n){
          this.value = n;
        }
      }
    },
    methods: {
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      confirmModal(){
        let id = '';
        if(this.value.id) id = this.value.id;
        this.$axios.delete(this.getUrl(this.value.url+id)).then(res=>{
          if(res.status===200){
            this.toast('삭제되었습니다.');
            this.$store.commit('closeModal', {url:this.value.url, id:this.value.id});
          }
        }).catch(res => {
          this.toast('삭제에 실패하였습니다.');
          this.$store.commit('cancelModal');
        });
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>


</style>
